/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    $LOWER_NAME$s: {
        menu: {
            index: 'بازاریاب‌ها',
            create: 'افزودن بازاریاب',
            list: 'بازاریاب‌ها'
        },
        table_titles: {
            id: 'شناسه',
            affiliate: 'نام بازاریاب',
            rebit_account: 'حساب Rebit',
            commission: 'کمیسیون (%)',
            contracted_at: 'تاریخ قرارداد',
            setting: 'ویرایش / حذف',
        },
        earnings: {
            index: 'درآمدها',
            month: 'ماه',
            total_usdt: 'مجموع (USDT)',
            commission_usdt: 'کمیسیون (USDT)',
            pay: 'پرداخت',
            settle_commission: 'تسویه حساب'
        },
        edit: 'ویرایش بازاریاب'
    }
}
